export default __webpack_public_path__ + "static/media/bg3.32c22452.jpeg";